import featureGroups from '@/config/featureGroups';

export function getAreaRangeLabel(featureGroup: string | undefined): string {
  if (featureGroup === featureGroups.FARMS.id) {
    return 'Tilan pinta-ala';
  } else if (featureGroup === featureGroups.SITES.id) {
    return 'Tontin pinta-ala';
  }
  return 'Pinta-ala';
}
